import {appPath} from "@/config/settings";

export function get_toolset_name_from_full_path(full_path) {
    let cleaned = full_path.replace(appPath,'');
    if (cleaned.startsWith('/')){
        cleaned = cleaned.replace(/^\/+/, '');
    }
    let toolsetName = '';
    if(cleaned.includes('/')){
        toolsetName = cleaned.split('/')[0]
    }else{
        toolsetName = cleaned
    }
    return toolsetName;
}